// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"a06cb503","320":"dcb1c59e","649":"599f0c69","870":"08d15b4d"}[chunkId] + ".chunk.js";
};